import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=4ff4080d&lang=pug&"
import script from "./Flow.vue?vue&type=script&lang=ts&"
export * from "./Flow.vue?vue&type=script&lang=ts&"
import style0 from "./Flow.vue?vue&type=style&index=0&id=4ff4080d&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports